/* eslint-disable max-len */
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { Observable, Subscription } from 'rxjs';
import { FormControl } from '@angular/forms';
import { PaginationParams } from 'src/app/model/api/pagination-params';
import { debounceTime, filter, map } from 'rxjs/operators';
import * as DeviceActions from 'src/app/store/device/device.actions';
import { TranslateService } from '@ngx-translate/core';
import { Site } from 'src/app/model/site';
import { DatePipe } from '@angular/common';
import { CAWeekDay, CAWeeklySchedule } from 'src/app/model/control-access';
import { selectCurrentSite } from 'src/app/store/site/site.selector';
import { selectCurrentDeviceStatus, selectMtmaGroupsPagination, selectMtmaGroupsMaxData, selectMtmaGroupModify, selectMtmaWeeklyScheduleModify, selectMtmaSpecialPlanningModify, selectMtmaActiveTask, selectMtmaGroups, selectMtmaTagsRules, selectMtmaKeypadsRules, selectMtmaContactsRules } from 'src/app/store/device/device.selector';
import { ControlAccessMaxData, ItemsPagination } from 'src/app/model/api/data-rest';
import { TableLazyLoadEvent } from 'primeng/table';
import { pageSortChange } from 'src/app/services/table';
import { ConfirmationService } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { StandardMtmaLayout, StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';
import { selectDeviceTabIndex } from 'src/app/store/home/home.selector';
import { DeviceStatus } from 'src/app/model/device-status';
import { MtmaControlAccessGroupEasyDialogDialogComponent } from '../mtma-control-access-group-easy-dialog/mtma-control-access-group-easy-dialog.component';
import { MTMA_GROUP_DEFAULT_SORT_COLUMN, MTMA_GROUP_DEFAULT_SORT_COLUMN_DIRECTION, MTMA_GROUP_PAGE_DEFAULT_SIZE, MTMA_GROUP_TABLE_HEADER } from 'src/app/conf/control-access-mtma';
import { MtmaRule, MtmaTimeslice } from 'src/app/model/mtma-rules-access';
import { MtmaTask } from 'src/app/model/mtma-task';
import { MtmaRuleAccessDialogComponent } from '../../mtma-rule-access-dialog/mtma-rule-access-dialog.component';
import moment from 'moment';
import { FlagTimeslice, MTMACAGroup, MTMACASpecialPlanning, MTMACAWeeklySchedule } from 'src/app/model/mtma-control-access';
import { MtmaTag } from 'src/app/model/mtma-tag';
import { MtmaKeypad } from 'src/app/model/mtma-keypad';
import { MtmaContact } from 'src/app/model/mtma-contact';
import { CommonCustomConfirmDialogComponent } from 'src/app/modules/shared/components/common-custom-confirm-dialog/common-custom-confirm.dialog.component';

@Component({
	selector: 'app-mtma-control-access-group-easy-list',
	templateUrl: './mtma-control-access-group-easy-list.component.html',
	providers: [ConfirmationService, DialogService]
})

export class MtmaControlAccessGroupEasyListComponent implements OnInit, OnDestroy {

	site$: Observable<Site | undefined>;
	siteSub: Subscription | undefined;
	mtmaGroups$: Observable<MTMACAGroup[] | undefined>;
	mtmaGroupsSub: Subscription | undefined;
	groupsPagination$: Observable<ItemsPagination | undefined>;
	groupsPaginationSub: Subscription | undefined;
	groupsMaxData$: Observable<ControlAccessMaxData | undefined>;
	groupsMaxDataSub: Subscription | undefined;
	groupsModify$: Observable<boolean | undefined>;
	groupsModifySub: Subscription | undefined;
	weeklyScheduleModify$: Observable<boolean | undefined>;
	weeklyScheduleModifySub: Subscription | undefined;
	specialPlanningModify$: Observable<boolean | undefined>;
	specialPlanningModifySub: Subscription | undefined;
	tabIndex: number;
	tabIndex$: Observable<number | undefined>;
	tabIndexSub: Subscription | undefined;
	deviceStatus: DeviceStatus;
	deviceStatus$: Observable<DeviceStatus | undefined>;
	deviceStatusSub: Subscription | undefined;
	mtmaActiveTask$: Observable<MtmaTask | undefined>;
	mtmaActiveTaskSub: Subscription | undefined;
	acMtmaTagsRule: MtmaTag[];
	acMtmaTagsRule$: Observable<MtmaTag[] | undefined>;
	acMtmaTagsRuleSub: Subscription | undefined;
	acMtmaKeypadsRule: MtmaKeypad[];
	acMtmaKeypadsRule$: Observable<MtmaKeypad[] | undefined>;
	acMtmaKeypadsRuleSub: Subscription | undefined;
	acMtmaContactsRule: MtmaContact[];
	acMtmaContactsRule$: Observable<MtmaContact[] | undefined>;
	acMtmaContactsRuleSub: Subscription | undefined;

	searchFilter: FormControl = new FormControl('');
	filterSub: Subscription;
	filter: '';

	groupColumns = MTMA_GROUP_TABLE_HEADER;
	groupPagingSub: Subscription;
	groupPageSortSub: Subscription;
	groupPaging: PaginationParams = {
		size: MTMA_GROUP_PAGE_DEFAULT_SIZE,
		page: 1,
		sort: MTMA_GROUP_DEFAULT_SORT_COLUMN,
		order: MTMA_GROUP_DEFAULT_SORT_COLUMN_DIRECTION,
	};
	groupPageSize: number = MTMA_GROUP_PAGE_DEFAULT_SIZE;
	// groupPageSizeOptions = MTMA_GROUP_PAGE_SIZE_OPTIONS;
	totalRecords: number;

	groupsMaxSizeMemorySub: Subscription;
	groupsMemorySize = 1;
	groupsMaxMemorySize = 1;

	isActiveTask = false;
	groupsLoading: boolean;
	mtmaGroups: MTMACAGroup[];

	online: boolean;
	currentSite: Site;

	groupConfirmDeleteSub: Subscription;

	dateTransform: DatePipe;

	ref: DynamicDialogRef | undefined;

	acceptButtonStyle: string;
	rejectButtonStyle: string;

	opened = false;

	// Design
	screenWidth: number;
	MIN_MD_WIDTH = 500;
	COLUMN_TITLE_MIN_WD = 647;
	MAX_MD_WIDTH = 1120;
	MIN_WIDTH_MX7 = 1700;
	LG_WIDTH = 1500;
	MAX_MD_WIDTH_SHORT = 858;

	constructor(
		private store: Store<AppState>,
		public confirmationService: ConfirmationService,
		private translate: TranslateService,
		public dialogService: DialogService,
	) {
		this.initSelectors();
	}

	initSelectors(): void {
		this.site$ = this.store.select(selectCurrentSite);
		this.mtmaGroups$ = this.store.select(selectMtmaGroups);
		this.groupsPagination$ = this.store.select(selectMtmaGroupsPagination);
		this.groupsMaxData$ = this.store.select(selectMtmaGroupsMaxData);
		this.groupsModify$ = this.store.select(selectMtmaGroupModify);
		this.tabIndex$ = this.store.select(selectDeviceTabIndex);
		this.weeklyScheduleModify$ = this.store.select(selectMtmaWeeklyScheduleModify);
		this.specialPlanningModify$ = this.store.select(selectMtmaSpecialPlanningModify);
		this.deviceStatus$ = this.store.select(selectCurrentDeviceStatus);
		this.mtmaActiveTask$ = this.store.select(selectMtmaActiveTask);
		this.acMtmaTagsRule$ = this.store.select(selectMtmaTagsRules);
		this.acMtmaKeypadsRule$ = this.store.select(selectMtmaKeypadsRules);
		this.acMtmaContactsRule$ = this.store.select(selectMtmaContactsRules);
	}

	ngOnInit(): void {
		const currentLang = this.translate.currentLang;

		this.dateTransform = new DatePipe(currentLang);
		this.subscribeAll();
		this.onResize();
	}

	subscribeAll(): void {
		this.filterSub = this.searchFilter.valueChanges.pipe(
			debounceTime(500),
			map(v => v.trim().toLowerCase())
		).subscribe(value => {
			this.groupsLoading = true;
			this.filter = value;
			this.dispatchGetGroups();
		});

		this.dispatchGetGroups();
		this.mtmaGroupsSub = this.mtmaGroups$.subscribe(mtmaGroups => {
			this.mtmaGroups = mtmaGroups;
			for (let i = 0; i < this.mtmaGroups.length; i++) {
				this.correctWeeklySchedule(this.mtmaGroups[i].WeeklySchedules);
				this.correctSpecialPlannings(this.mtmaGroups[i].SpecialPlannings);
			}
			this.groupsLoading = false;
		});

		this.groupsPaginationSub = this.groupsPagination$
			.pipe(filter(p => !!p))
			.subscribe(paging => {
				this.totalRecords = paging.TotalCount;
			}
			);

		this.groupsMaxSizeMemorySub = this.groupsMaxData$
			.pipe(filter(p => !!p))
			.subscribe(groupsMemorySizeMaxData => {
				this.groupsMemorySize = groupsMemorySizeMaxData.Current;
				this.groupsMaxMemorySize = groupsMemorySizeMaxData.Max;
			}
			);

		this.groupsModifySub = this.groupsModify$
			.pipe(filter(groupsModify => !!groupsModify))
			.subscribe(() => {
				this.dispatchGetGroups();
			});


		this.weeklyScheduleModifySub = this.weeklyScheduleModify$
			.pipe(filter(weeklyScheduleModify => !!weeklyScheduleModify))
			.subscribe(() => {
				this.dispatchGetGroups();
			});
		this.specialPlanningModifySub = this.specialPlanningModify$
			.pipe(filter(specialPlanningModify => !!specialPlanningModify))
			.subscribe(() => {
				this.dispatchGetGroups();
			});
		this.siteSub = this.site$.subscribe(currentSite => {
			this.currentSite = currentSite;
		});
		this.tabIndexSub = this.tabIndex$?.subscribe(
			async (tabIndex: number) => {
				this.tabIndex = tabIndex;
				this.dispatchGetGroups();
			});
		this.deviceStatusSub = this.deviceStatus$.subscribe(deviceStatus => {
			this.deviceStatus = deviceStatus;
			if (this.deviceStatus !== undefined) {
				this.online = deviceStatus.Online;
			}
		});
		this.mtmaActiveTaskSub = this.mtmaActiveTask$.subscribe(mtmaActiveTask => {
			if (mtmaActiveTask.Id !== '') {
				this.isActiveTask = true;
			} else {
				this.isActiveTask = false;
			}
		});
		this.acMtmaTagsRuleSub = this.acMtmaTagsRule$.subscribe(acMtmaTagsRule => {
			this.acMtmaTagsRule = acMtmaTagsRule;
		});
		this.acMtmaKeypadsRuleSub = this.acMtmaKeypadsRule$.subscribe(acMtmaKeypadsRule => {
			this.acMtmaKeypadsRule = acMtmaKeypadsRule;
		});
		this.acMtmaContactsRuleSub = this.acMtmaContactsRule$.subscribe(acMtmaContactsRule => {
			this.acMtmaContactsRule = acMtmaContactsRule;
		});
	}

	ngOnDestroy(): void {
		this.groupsModifySub?.unsubscribe();
		this.siteSub?.unsubscribe();
		this.specialPlanningModifySub?.unsubscribe();
		this.weeklyScheduleModifySub?.unsubscribe();
		this.groupsMaxSizeMemorySub?.unsubscribe();
		this.tabIndexSub?.unsubscribe();
		this.deviceStatusSub?.unsubscribe();
		this.mtmaActiveTaskSub?.unsubscribe();
		this.groupsPaginationSub?.unsubscribe();
		this.acMtmaTagsRuleSub?.unsubscribe();
		this.acMtmaKeypadsRuleSub?.unsubscribe();
		this.acMtmaContactsRuleSub?.unsubscribe();
	}


	loadGroups(event: TableLazyLoadEvent) {
		this.groupsLoading = true;

		this.groupPaging = pageSortChange(this.groupPaging, event);

		this.dispatchGetGroups();
	}

	dispatchGetGroups(): void {
		if (this.isSelectTab()) {
			this.store.dispatch(DeviceActions.getMtmaGroups({
				filter: this.filter,
				sort: this.groupPaging.sort, order: this.groupPaging.order, size: this.groupPaging.size, page: this.groupPaging.page
			}));
		}
	}

	isControlAccess(): boolean {
		// TAB INDEX FOR MTMACONNECT IS 8 tab only for mtma
		// trigger GET apis is based on open accordion, not based on tabIndex number
		return true;
	}

	isSelectTab(): boolean {
		return this.isControlAccess() && this.opened;
	}

	addGroup(): void {
		this.store.dispatch(DeviceActions.resetMtmaGroupForm());
		this.ref = this.dialogService.open(MtmaControlAccessGroupEasyDialogDialogComponent, {
			header: this.translate.instant('ADD_GROUP'),
			width: '75vw',
			breakpoints: { '1600px': '98vw' },
			contentStyle: { overflow: 'auto' },
		});
	}

	editGroup(group: MtmaRule): void {
		this.store.dispatch(DeviceActions.resetMtmaGroupForm());
		this.ref = this.dialogService.open(MtmaControlAccessGroupEasyDialogDialogComponent, {
			header: this.translate.instant('EDIT_GROUP'),
			width: '75vw',
			breakpoints: { '1600px': '98vw' },
			contentStyle: { overflow: 'auto' },
			data: { group },
		});
	}

	deleteGroup(group: MtmaRule): void {
		this.store.dispatch(DeviceActions.resetMtmaGroupForm());
		this.groupsLoading = true;
		this.store.dispatch(DeviceActions.getMtmaRulesAccess({ ruleId: group.Id }));

		setTimeout(() => {
			this.groupsLoading = false;
			let dataDialogObj = {};

			if (this.acMtmaContactsRule !== undefined && this.acMtmaContactsRule.length > 0 ||
				this.acMtmaKeypadsRule !== undefined && this.acMtmaKeypadsRule.length > 0 ||
				this.acMtmaTagsRule !== undefined && this.acMtmaTagsRule.length > 0
			) {
				dataDialogObj = {
					icon: 'cm-alert',
					row1: 'MTMA_GROUP_HAS_ASSOCIATIONS',
					row2: 'DELETE_GROUP_WARNING',
					classAcceptButton: 'p-button-danger',
				};
			} else {
				dataDialogObj = {
					icon: 'cm-alert',
					row1: 'DELETE_GROUP_WARNING',
					classAcceptButton: 'p-button-danger',
				};
			}

			const childRefCallsLogEnable = this.dialogService.open(CommonCustomConfirmDialogComponent, {
				header: this.translate.instant('DELETE_GROUP'),
				contentStyle: { overflow: 'auto' },
				data: dataDialogObj
			});
			childRefCallsLogEnable.onClose.subscribe((accepted: boolean) => {
				if (accepted) {
					this.store.dispatch(DeviceActions.deleteGroup({ groupId: group.Id }));
				}
			});
		}, 700);
	}

	daysOfWeekSchedule(weeklySchedule: CAWeeklySchedule): CAWeekDay[] {
		const currentWeekDays = [
			{ Value: '0', Name: 'SUN', Enable: false },
			{ Value: '1', Name: 'MON', Enable: false },
			{ Value: '2', Name: 'TUE', Enable: false },
			{ Value: '3', Name: 'WED', Enable: false },
			{ Value: '4', Name: 'THU', Enable: false },
			{ Value: '5', Name: 'FRI', Enable: false },
			{ Value: '6', Name: 'SAT', Enable: false },
		];
		const ppp = [];
		let value = weeklySchedule.Weekdays;
		for (let i = 6; i > -1; i--) {
			if (value !== 0 && value / (2 ** i) >= 1) {
				ppp.unshift(i.toString());
				currentWeekDays[i].Enable = true;
			}
			value = value % (2 ** i);
		}
		// UI: we start from index 1 (MON) and we put SUN at the end of the list (index 0)
		return [...currentWeekDays.slice(1), currentWeekDays[0]];
	}

	getNumWeeklySchedule(group: MtmaRule): number {
		if (group.WeeklySchedules === undefined) {
			return 0;
		}
		return group.WeeklySchedules.length;
	}


	getNumSpecialPlanning(group: MtmaRule): number {
		if (group.SpecialPlannings === undefined) {
			return 0;
		}
		return group.SpecialPlannings.length;
	}

	getValueMemory(): number {
		return Math.ceil((this.groupsMemorySize / this.groupsMaxMemorySize) * 100);
	}

	togglePanel(opened: boolean): void {
		this.opened = opened;
		this.dispatchGetGroups();
	}

	openRuleAccess(rule: MtmaRule): void {
		this.store.dispatch(DeviceActions.resetMtmaRulesAccessForm());
		this.ref = this.dialogService.open(MtmaRuleAccessDialogComponent, {
			header: this.translate.instant('MANAGE_ACCESSES'),
			width: '75vw',
			breakpoints: { '1250px': '98vw' },
			contentStyle: { overflow: 'auto' },
			data: { rule },
		});
	}


	correctSpecialPlannings(specialPlannings: MTMACASpecialPlanning[]): void {
		if (specialPlannings != undefined && specialPlannings.length > 0) {
			for (let i = 0; i < specialPlannings.length; i++) {
				specialPlannings[i].Access = this.isAccessSpecialPlanning(specialPlannings[i]);
				specialPlannings[i].Old = this.isOldSpecialPlanning(specialPlannings[i]);
			}
		}
	}

	correctWeeklySchedule(weeklySchedules: MTMACAWeeklySchedule[]): void {
		if (weeklySchedules != undefined && weeklySchedules.length > 0) {
			for (let i = 0; i < weeklySchedules.length; i++) {
				weeklySchedules[i].Access = this.isAccessWeeklySchedule(weeklySchedules[i]);
				weeklySchedules[i].Old = this.isOldWeeklySchedule(weeklySchedules[i]);
			}
		}
	}

	isAccessSpecialPlanning(specialPlanning: MTMACASpecialPlanning): boolean {
		if ((specialPlanning.Flags & (1 << 0)) > 0) {
			return true;
		}
		return false;
	}


	isOldSpecialPlanning(specialPlanning: MTMACASpecialPlanning): boolean {
		if ((specialPlanning.Flags & (1 << 1)) > 0) { // bit1
			return true;
		}
		if ((specialPlanning.Flags & (1 << 2)) > 0) { // bit2
			return true;
		}
		if ((specialPlanning.Flags & (1 << 3)) > 0) { // bit3
			return true;
		}
		if ((specialPlanning.Flags & (1 << 4)) > 0) { // bit4
			return true;
		}
		if ((specialPlanning.Flags & (1 << 5)) > 0) { // bit5
			return true;
		}
		if ((specialPlanning.Flags & (1 << 6)) > 0) { // bit6
			return true;
		}
		return false;
	}

	isAccessWeeklySchedule(weeklySchedule: MTMACAWeeklySchedule): boolean {
		if ((weeklySchedule.Flags & (1 << 0)) > 0) {
			return true;
		}
		return false;
	}

	isOldWeeklySchedule(specialPlanning: MTMACAWeeklySchedule): boolean {
		if ((specialPlanning.Flags & (1 << 0)) === 0) { // bit0
			return true;
		}
		if ((specialPlanning.Flags & (1 << 1)) > 0) { // bit1
			return true;
		}
		if ((specialPlanning.Flags & (1 << 2)) > 0) { // bit2
			return true;
		}
		if ((specialPlanning.Flags & (1 << 3)) > 0) { // bit3
			return true;
		}
		if ((specialPlanning.Flags & (1 << 4)) > 0) { // bit4
			return true;
		}
		if ((specialPlanning.Flags & (1 << 5)) > 0) { // bit5
			return true;
		}
		if ((specialPlanning.Flags & (1 << 6)) > 0) { // bit6
			return true;
		}
		return false;
	}

	getTime(dtFrom: string): string {
		return dtFrom.split('T')[1];
	}


	//---------------------OLD VERSIONE

	getRepetitionTimeslice(timeslice: MtmaTimeslice): number {
		const listFlag = [];
		let value = timeslice.Flags;
		for (let i = 3; i > -1; i--) {
			if (value !== 0 && value / (2 ** i) >= 1) {
				listFlag.push(1);
			} else {
				listFlag.push(0);
			}
			value = value % (2 ** i);
		}
		if (listFlag[3 - FlagTimeslice.REPETITION_MONTHLY] === 1) {
			return FlagTimeslice.REPETITION_MONTHLY;
		} else if (listFlag[3 - FlagTimeslice.REPETITION_ANNUAL] === 1) {
			return FlagTimeslice.REPETITION_ANNUAL;
		}
		return 0;
	}

	getLabelRepetition(repetition: number): string {
		switch (repetition) {
			case 2: {   // MONTLY
				return this.translate.instant('MONTHLY');
			}
			case 3: {   // ANNUAL
				return this.translate.instant('REPETITION_ANNUAL');
			}
			default: {
				return "-";
			}
		}
	}

	getColorRepetition(repetition: number): string {
		switch (repetition) {
			case 2: {   // MONTLY
				return 'w-10rem p-tag-lightBlue0220';
			}
			case 3: {   // ANNUAL
				return 'w-10rem p-tag-lightBlue0240';
			}
			default: {
				return 'w-10rem p-tag-darkBlue10';
			}
		}
	}


	getDetailsTimeSpecialPlanning(timeslice: MtmaTimeslice): string {
		let date1 = '';
		let date2 = '';
		let time1 = '';
		let time2 = '';
		const momFrom = moment.utc(timeslice.DtFrom);
		const momTo = moment.utc(timeslice.DtTo);
		const repetition = this.getRepetitionTimeslice(timeslice);
		if (repetition === FlagTimeslice.REPETITION_MONTHLY) {
			const listFlag = [];
			let value = timeslice.Flags;
			for (let i = 6; i > -1; i--) {
				if (value !== 0 && value / (2 ** i) >= 1) {
					listFlag.push(1);
				} else {
					listFlag.push(0);
				}
				value = value % (2 ** i);
			}
			let dayMonthStart = momFrom.utc().date();
			let dayMonthEnd = momTo.utc().date();
			if (listFlag[6 - FlagTimeslice.DATE_29] + listFlag[6 - FlagTimeslice.DATE_30] + listFlag[6 - FlagTimeslice.DATE_31] > 0) {
				if (listFlag[6 - FlagTimeslice.DATE_31] === 1) {
					dayMonthEnd = 31;
				}
				if (listFlag[6 - FlagTimeslice.DATE_30] === 1 && listFlag[6 - FlagTimeslice.DATE_31] === 1) {
					dayMonthStart = 30;
				} else if (listFlag[6 - FlagTimeslice.DATE_30] === 1 && listFlag[6 - FlagTimeslice.DATE_31] === 0) {
					dayMonthEnd = 30;
				}
				if (listFlag[6 - FlagTimeslice.DATE_29] === 1 && (listFlag[6 - FlagTimeslice.DATE_31] === 1 || listFlag[6 - FlagTimeslice.DATE_30] === 1)) {
					dayMonthStart = 29;
				} else if (listFlag[6 - FlagTimeslice.DATE_29] === 1 && listFlag[6 - FlagTimeslice.DATE_31] === 0 && listFlag[6 - FlagTimeslice.DATE_30] === 0) {
					dayMonthEnd = 29;
				}
			}
			date1 = this.translate.instant('DAY_FROM') + ' ' + dayMonthStart;
			date2 = this.translate.instant('DAY_TO') + ' ' + dayMonthEnd;
			/*detail = detail + ' ' + this.translate.instant('DAY_FROM') + ' ' + dayMonthStart +
				' - ' + this.translate.instant('DAY_TO') + ' ' + dayMonthEnd;*/
			time1 = this.translate.instant('HOURS') + ' ' + momFrom.utc().format('HH:mm');
			time2 = this.translate.instant('HOURS') + ' ' + momTo.utc().format('HH:mm');
			/*detail = detail + ' ' + this.translate.instant('DATE_FROM') + ' ' + momFrom.format('HH:mm') +
			' - ' + this.translate.instant('DATE_TO') + ' ' + momTo.format('HH:mm');*/
		} else if (repetition === FlagTimeslice.REPETITION_ANNUAL) {
			date1 = this.translate.instant('DAY_MONTH_FROM') + ' ' + momFrom.utc().format('DD/MM');
			date2 = this.translate.instant('DAY_MONTH_TO') + ' ' + momTo.utc().format('DD/MM');
			/*detail = detail + ' ' + this.translate.instant('DAY_MONTH_FROM') + ' ' + momFrom.utc().format('DD/MM') +
				' - ' + this.translate.instant('DAY_MONTH_TO') + ' ' + momTo.utc().format('DD/MM');*/
			time1 = this.translate.instant('HOURS') + ' ' + momFrom.utc().format('HH:mm');
			time2 = this.translate.instant('HOURS') + ' ' + momTo.utc().format('HH:mm');
			/*detail = detail + ' ' + this.translate.instant('DATE_FROM') + ' ' + momFrom.format('HH:mm') +
			' - ' + this.translate.instant('DATE_TO') + ' ' + momTo.format('HH:mm');*/
		}
		return date1 + ' ' + time1 + ' - ' + date2 + ' ' + time2;
	}


	getDetailsTimeslice(timeslice: MtmaTimeslice): string {
		let detail = '';
		const momFrom = moment(timeslice.DtFrom);
		const momTo = moment(timeslice.DtTo);
		if (timeslice.Type === 2) {
			const repetition = this.getRepetitionTimeslice(timeslice);
			if (repetition === FlagTimeslice.REPETITION_MONTHLY) {
				const listFlag = [];
				let value = timeslice.Flags;
				for (let i = 6; i > -1; i--) {
					if (value !== 0 && value / (2 ** i) >= 1) {
						listFlag.push(1);
					} else {
						listFlag.push(0);
					}
					value = value % (2 ** i);
				}
				let dayMonthStart = momFrom.utc().date();
				let dayMonthEnd = momTo.utc().date();
				if (listFlag[6 - FlagTimeslice.DATE_29] + listFlag[6 - FlagTimeslice.DATE_30] + listFlag[6 - FlagTimeslice.DATE_31] > 0) {
					if (listFlag[6 - FlagTimeslice.DATE_31] === 1) {
						dayMonthEnd = 31;
					}
					if (listFlag[6 - FlagTimeslice.DATE_30] === 1 && listFlag[6 - FlagTimeslice.DATE_31] === 1) {
						dayMonthStart = 30;
					} else if (listFlag[6 - FlagTimeslice.DATE_30] === 1 && listFlag[6 - FlagTimeslice.DATE_31] === 0) {
						dayMonthEnd = 30;
					}
					if (listFlag[6 - FlagTimeslice.DATE_29] === 1 && (listFlag[6 - FlagTimeslice.DATE_31] === 1 || listFlag[6 - FlagTimeslice.DATE_30] === 1)) {
						dayMonthStart = 29;
					} else if (listFlag[6 - FlagTimeslice.DATE_29] === 1 && listFlag[6 - FlagTimeslice.DATE_31] === 0 && listFlag[6 - FlagTimeslice.DATE_30] === 0) {
						dayMonthEnd = 29;
					}
				}
				detail = detail + ' ' + this.translate.instant('DAY_FROM') + ' ' + dayMonthStart +
					' - ' + this.translate.instant('DAY_TO') + ' ' + dayMonthEnd;
			} else if (repetition === FlagTimeslice.REPETITION_ANNUAL) {
				detail = detail + ' ' + this.translate.instant('DAY_MONTH_FROM') + ' ' + momFrom.utc().format('DD/MM') +
					' - ' + this.translate.instant('DAY_MONTH_TO') + ' ' + momTo.utc().format('DD/MM');
			}

		}
		return detail;
	}


	getTimeTimeslice(timeslice: MtmaTimeslice): string {
		const momFrom = moment(timeslice.DtFrom);
		const momTo = moment(timeslice.DtTo);


		let detail = '';
		detail = detail + ' ' + this.translate.instant('DATE_FROM') + ' ' + momFrom.format('HH:mm') +
			' - ' + this.translate.instant('DATE_TO') + ' ' + momTo.format('HH:mm');

		return detail;
	}

	getTemporaryTimeslice(timeslice: MtmaTimeslice): string {
		const listFlag = [];
		const momFrom = moment(timeslice.DtFrom);
		const momTo = moment(timeslice.DtTo);
		let value = timeslice.Flags;
		for (let i = 6; i > -1; i--) {
			if (value !== 0 && value / (2 ** i) >= 1) {
				listFlag.push(1);
			} else {
				listFlag.push(0);
			}
			value = value % (2 ** i);
		}
		let detail = '-';
		if (listFlag[6 - FlagTimeslice.TEMPORARY] === 1) {
			if (timeslice.Type === 1) {
				detail = this.translate.instant('FROM') + ' ' + momFrom.format('DD/MM/yyyy') +
					' - ' + this.translate.instant('TO') + ' ' + momTo.format('DD/MM/yyyy');
			} else if (timeslice.Type === 2) {
				const repetition = this.getRepetitionTimeslice(timeslice);
				if (repetition === FlagTimeslice.REPETITION_MONTHLY) {
					detail = this.translate.instant('DAY_MONTH_FROM') + ' ' + momFrom.format('MM/yyyy') +
						' - ' + this.translate.instant('DAY_MONTH_TO') + ' ' + momTo.format('MM/yyyy');
				} else if (repetition === FlagTimeslice.REPETITION_ANNUAL) {
					detail = this.translate.instant('FROM') + ' ' + momFrom.format('yyyy') +
						' - ' + this.translate.instant('TO') + ' ' + momTo.format('yyyy');
				}

			}
		}
		return detail;
	}

	//---------------------OLD VERSIONE

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile() {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	actionLayout(position: string): string {
		return StandardMtmaLayout.actionLayout(this.screenWidth, position);
	}

	layoutMarginResponsive(): string {
		return StandardPageLayout.layoutMarginResponsive(this.screenWidth);
	}

	dynamicInputSearchWidth(): string {
		return StandardMtmaLayout.dynamicInputSearchWidth(this.screenWidth, 'w-25rem');
	}

	col12Responsive(): string {
		return StandardPageLayout.col6Responsive(this.screenWidth);
	}
}
